import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="images/estimate.jpg"
        alt="cta"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-primary-950/75"></div>
      <div className="relative z-10 mx-auto max-w-4xl px-4 md:px-10 text-center text-background-50">
        <p className="text-primary-300 text-xs md:text-sm tracking-[0.3em] uppercase mb-5">
          Free Estimate
        </p>
        <h2 className="font-heading text-3xl md:text-5xl leading-tight mb-6">
          相見積、歓迎いたします。
        </h2>
        <p className="text-background-100/90 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-10">
          「今の会社と比較したい」——そういったご相談も歓迎です。
          現地確認とお見積は完全無料。しつこい営業も一切いたしません。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Link
            to="/contact"
            className="bg-accent-500 hover:bg-accent-600 text-background-50 px-8 py-4 rounded-md text-sm md:text-base font-medium whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-mail-send-line"></i>
            フォームで見積依頼（無料）
          </Link>
          <a
            href="tel:092-984-5214"
            className="border border-background-100/60 text-background-50 hover:bg-background-50/10 px-8 py-4 rounded-md text-sm md:text-base whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-phone-line"></i>
            電話で相談 092-984-5214
          </a>
        </div>
      </div>
    </section>
  );
}